module.exports = __webpack_public_path__ + "static/img/1_IMG_20151228_140118.d46b1e10.jpg";